import React from 'react';

import { SettingsCoordinator } from '~settings-coordinator/SettingsCoordinator';

import { IRemoteAgentConnectionStatus } from '../bridge-settings/serverApi/requests/GetSiteRemoteAgentsConnectionStatusRequest';
import { ISiteAdminPrivateConnectSettings, PrivateConnectSettings } from './PrivateConnectSettings';

export type SitePrivateConnectSettingsForSiteAdminProps = {
  settings: { // this is the same as the type of the response body  in the get bridge settings API response
    id?: string; // id shouldnt be in the settings passed on to settings
    siteAdminPrivateConnectSettings?: ISiteAdminPrivateConnectSettings;
  };
  connectionStatuses?: IRemoteAgentConnectionStatus[];
};

/**
 * Creates a settings coordinator with the private connect settings
 */
export function PrivateConnectSettingsCoordinator(props: SitePrivateConnectSettingsForSiteAdminProps) {

  return (
    <SettingsCoordinator>
      <PrivateConnectSettings {...props} />
    </SettingsCoordinator>
  );
}